module.exports = __webpack_public_path__ + "img/emfi-logo.98ad991c.svg";